/**
 * Regla de negocio: las acciones sobre acuerdos mutuos (crear, actualizar y cerrar)
 * no pueden tener una fecha anterior a 30 días hacia atrás desde la fecha actual.
 *
 * Toda la lógica vive acá para que las 4 pantallas que la usan no se desincronicen:
 *  - views/AcuerdoMutuo.js            (crear)
 *  - views/NuevoAcuerdoMutuo2.js      (crear v2)
 *  - views/AcuerdosMutuos.js          (actualizar / cerrar, página standalone)
 *  - views/components/ModalAcuerdosMutuos.js (actualizar / cerrar, desde el calendario)
 */

export const DIAS_MAX_RETROACTIVO_ACUERDO = 30;

/** Fecha de hoy en formato YYYY-MM-DD, en hora local (no UTC). */
export const getFechaLocalHoy = () => {
    const ahora = new Date();
    ahora.setMinutes(ahora.getMinutes() - ahora.getTimezoneOffset());
    return ahora.toISOString().slice(0, 10);
};

/** Normaliza cualquier fecha (Date, ISO, datetime) a YYYY-MM-DD. */
export const normalizeFechaISO = (value) => (value ? String(value).slice(0, 10) : "");

/**
 * Fecha mínima permitida (YYYY-MM-DD): hoy menos DIAS_MAX_RETROACTIVO_ACUERDO días.
 * Sirve directamente para el atributo `min` de un <input type="date">.
 */
export const getFechaMinimaAcuerdo = () => {
    const limite = new Date();
    limite.setDate(limite.getDate() - DIAS_MAX_RETROACTIVO_ACUERDO);
    limite.setMinutes(limite.getMinutes() - limite.getTimezoneOffset());
    return limite.toISOString().slice(0, 10);
};

/** true si la fecha está dentro del rango permitido (o si viene vacía). */
export const esFechaAcuerdoValida = (fecha) => {
    const f = normalizeFechaISO(fecha);
    if (!f) return true;
    return f >= getFechaMinimaAcuerdo();
};

/**
 * Devuelve el mensaje de error si la fecha excede el límite, o "" si es válida.
 * @param {string} fecha  Fecha a validar.
 * @param {string} etiqueta  Cómo nombrar el campo en el mensaje.
 */
export const validarFechaAcuerdo = (fecha, etiqueta = "La fecha") => {
    if (esFechaAcuerdoValida(fecha)) return "";

    const minima = getFechaMinimaAcuerdo();
    return `${etiqueta} no puede ser anterior a ${DIAS_MAX_RETROACTIVO_ACUERDO} días hacia atrás. `
        + `Fecha mínima permitida: ${minima}.`;
};
